import React from 'react';
import { Link } from 'react-router-dom';

const About: React.FC = () => {
    return (
        <section id="about" className="py-12 md:py-20 bg-background">
            <div className="max-w-6xl mx-auto px-4">
                <h2 className="text-4xl md:text-6xl font-bold mb-8 md:mb-16 transform rotate-1">ABOUT ME</h2>
                <div className="grid md:grid-cols-2 gap-8 md:gap-12">
                    <div className="hidden md:block brutalist-container transform -rotate-2 order-2 md:order-1">
                        <div className="aspect-square bg-surface-alt mb-4">
                            <img 
                                src="/assets/já.jpg" 
                                alt="Professional headshot"
                                className="w-full h-full object-cover"
                                loading="lazy"
                            />
                        </div>
                    </div>
                    <div className="brutalist-container transform rotate-1 order-1 md:order-2">
                        <div className="space-y-6">
                            <div>
                                <h3 className="text-xl md:text-2xl font-bold mb-3">OVERVIEW</h3>
                                <p className="brutalist-text text-sm md:text-base mb-6">
                                    I build digital products and cooperative ventures across Europe.
                                </p>
                                <p className="brutalist-text text-sm md:text-base mb-3">
                                    My background combines IT analytics with hands-on entrepreneurship through Tiimiakatemia and Erasmus for Young Entrepreneurs.
                                </p>
                                <p className="brutalist-text text-sm md:text-base">
                                    Currently focused on Siella.fi - personalized map posters for the Finnish market.
                                </p>
                            </div>

                            <div className="pt-6">
                                <Link to="/contact" className="brutalist-button w-full md:w-auto text-center">LET'S CONNECT</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;